export const SW_INIT = 'SW_INIT';
export const SW_UPDATE = 'SW_UPDATE';